export default __webpack_public_path__ + "KaTeX_Size3-Regular.f32a9fde642521722ca1d952e1aa1834.woff";